import React from 'react';
import LOGO_LOFT from '../assets/images/logo-loft.png';

function Footer() {
  return (
    <div className="footer">
      <img src={LOGO_LOFT} alt="Loft Media Latam" />
      <span className="footer-copy">© 2020 <a href="https://gameif.media/">GAMEIF</a></span>
      <span className="footer-maker">Powered by <a href="http://www.loftpublicidad.com/" targe="_blank">Loft Media</a></span>
    </div>
  );
}

export default Footer;